import { HALLOWEEN_PROMO_GIFT_COUPON } from '../campaign';

/** Coupon code for new user free shipping (first order) */
export const NEW_USER_FREESHIP_COUPON_CODE = 'newfreeship';

/** @deprecated Use NEW_USER_FREESHIP_COUPON_CODE instead */
export const FREESHIPPING_COUPON_CODE = NEW_USER_FREESHIP_COUPON_CODE;

/** App exclusive coupon codes - applied automatically when logged in on mobile app */
export const APP_EXCLUSIVE_COUPON_CODE = 'app20_skin_seoul';
export const APP_EXCLUSIVE_COUPON_CODE_10 = 'app10_skin_seoul';

/** All app exclusive coupon codes */
export const APP_EXCLUSIVE_COUPON_CODES = [APP_EXCLUSIVE_COUPON_CODE, APP_EXCLUSIVE_COUPON_CODE_10] as const;

/** Coupons that should be hidden from user interface but still functional */
export const HIDDEN_COUPONS_AT_DISCOUNT_SECTION = [...APP_EXCLUSIVE_COUPON_CODES];

/** Coupon code prefixes that cannot be manually applied (auto-applied by rule engine / app-exclusive) */
export const BLOCKED_MANUAL_APPLY_PREFIXES = ['bmsm', 'app'] as const;

/** Check if a coupon code is blocked from manual application */
export const isBlockedManualApplyCoupon = (couponCode: string): boolean => {
  const normalized = couponCode.toLowerCase();
  return BLOCKED_MANUAL_APPLY_PREFIXES.some((prefix) => normalized.startsWith(prefix));
};

/** Error message for blocked coupon codes */
export const BLOCKED_COUPON_ERROR_MESSAGE = 'This coupon cannot be applied.';

export const COUPONS_EXEMPT_FROM_LIMIT = [NEW_USER_FREESHIP_COUPON_CODE, HALLOWEEN_PROMO_GIFT_COUPON];

/**
 * Get display name for a coupon code.
 * App-exclusive codes (e.g. `app20_skin_seoul`) are normalized to their
 * leading segment in uppercase (e.g. `APP20`) to hide the internal suffix.
 */
export const getCouponDisplayName = (couponCode: string): string => {
  if (couponCode.toLowerCase().startsWith('app')) {
    return couponCode.split('_')[0].toUpperCase();
  }
  return couponCode;
};
